if (!customElements.get("delivery-deadline")) {
  class DeliveryDeadline extends HTMLElement {
    constructor() {
      super();
      this.localDate = "";
      this.localDay = "";
      this.elementData = this.getAttribute("data-delivery-deadline") || false;
      this.elementDataJson = this.elementData
        ? JSON.parse(this.elementData)
        : {};
      this.icon =
        this.parentNode.querySelector("[data-delivery-deadline-icon]") || false;
      this.init();
    }

    /**
     * Transforms the hour string XX:XX into a JS Date
     */
    getDeadlineDate(time, offset) {
      if (time != "") {
        const split = time.split(":");
        if (split[0] && split[1]) {
          const date = new Date();
          date.setHours(split[0], split[1], 0);
          return new Date((date.getTime() / 1000 - offset) * 1000);
        }
        return "";
      }
    }

    async init() {
      const cookies = Object.fromEntries(
        document.cookie.split(";").map((i) => i.trim().split("="))
      );
      let message = "";
      let weekday = "sunday";
      let insideTimeRange = false;

      let locationTime = {};

      function getDayName(locale) {
        let date = new Date();
        return date.toLocaleDateString(locale, { weekday: "long" });
      }
      var day = getDayName("en-EN").toLowerCase();

      locationTime.day = day;
      locationTime.date = new Date();
      locationTime.offset = 0;

      // Set weekday
      if (locationTime.day != "") weekday = locationTime.day;

      // Does weekday exists in JSON?
      if (this.elementDataJson[weekday] !== undefined) {
        // Set Deadline
        const deadlineContent = this.elementDataJson[weekday]?.deadline || "";
        const deadlineTime = this.getDeadlineDate(
          deadlineContent,
          locationTime.offset
        );

        // Is deadline expired?
        if (locationTime.date.getTime() < deadlineTime.getTime()) {
          // Switch on show message
          insideTimeRange = true;
        }
      }

      // Does weekday exists in JSON?
      if (this.elementDataJson[weekday] !== undefined) {
        // Default message
        message = this.elementDataJson[weekday].outside || "";

        // Get deadline time set in admin
        const deadline = this.elementDataJson[weekday].deadline || "";

        // Check if inside time range
        if (insideTimeRange) {
          // Inside time range message
          message = this.elementDataJson[weekday].inside || "";
        }

        // Message to display
        message = message.replace(/\[\[time\]\]/gi, deadline);
        if (message != "") {
          this.querySelector("p").innerText = message;
        }
      }
    }
  }
  customElements.define("delivery-deadline", DeliveryDeadline);
}
